module.exports = __webpack_public_path__ + "media/auto_history/odnalezienie-76a46d6c.svg";